/**
 * Fil d'Ariane repliable (fiches produit).
 *
 * Le bouton ne fait que basculer l'affichage : tous les maillons sont de vrais
 * liens présents dans le HTML dès le chargement, rien n'est chargé au clic.
 * Le JSON-LD (mm-micro-data-breadcrumbs) décrit le parcours complet, identique
 * à celui que l'utilisateur peut déplier.
 *
 * Accessibilité : l'élément est un <button>, donc déjà actionnable au clavier
 * (Entrée et Espace). On maintient aria-expanded et on échange l'aria-label
 * entre « Afficher / Masquer les catégories parentes ».
 *
 * Délégation d'événement : le snippet peut être rendu par plusieurs sections,
 * et la garde ci-dessous évite un double abonnement si le script est inclus
 * plus d'une fois.
 */
(function () {
	if (window.__cimBreadcrumbsInit) return;
	window.__cimBreadcrumbsInit = true;

	document.addEventListener('click', function (event) {
		const toggle = event.target.closest('[data-breadcrumb-toggle]');
		if (!toggle) return;

		const list = document.getElementById(toggle.getAttribute('aria-controls'));
		if (!list) return;

		const isCollapsed = list.dataset.collapsed !== 'false';
		list.dataset.collapsed = isCollapsed ? 'false' : 'true';
		toggle.setAttribute('aria-expanded', isCollapsed ? 'true' : 'false');

		const label = isCollapsed ? toggle.dataset.labelCollapse : toggle.dataset.labelExpand;
		if (label) toggle.setAttribute('aria-label', label);

		// Deplie, la fleche n'a plus d'objet : on la sort du flux et du parcours
		// clavier. Le maillon suivant devient alors le premier et s'aligne sur le
		// titre du produit. Le repli n'est plus possible, l'information etant
		// desormais entiere.
		const item = toggle.closest('.mm-breadcrumb-toggle-item');
		if (item) item.hidden = isCollapsed;
	});
})();
